// extracted by mini-css-extract-plugin
export default {"pageHeader":"yr__jz","title":"yV_v7o","subtitle":"k8LQFG","dots":"H14Bel","dot":"_JdZrG","active":"BI382p"};